import { useState } from 'react';
import PropTypes from 'prop-types';
import { getTeacherInfo } from 'legacy-src/queries';
import useGetActions from './useGetActions';

const useFetchTeacher = (props) => {
  const { client, subject, dispatch } = props;
  const [state, setState] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const actions = useGetActions({
    dispatch,
  });

  const loadTeacherInfo = ({
    educationPeriodCode,
    userData,
    router,
    params,
  }) => {
    setIsLoading(true);
    client
      .query({
        query: getTeacherInfo,
        fetchPolicy: 'network-only',
        variables: {
          id: subject,
          educationPeriod: educationPeriodCode,
        },
      })
      .then((response) => {
        const {
          data: {
            teacherSubject: { classes, subjects },
          },
        } = response;

        setState(response);
        actions.setItemsAction(classes);
        actions.setUserSubjectsAction({ subjects });
        actions.setSubjectAction(userData, router, params);
        actions.setStudentsBySectionAction(userData, params);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return [state, loadTeacherInfo, isLoading];
};

useFetchTeacher.propTypes = {
  client: PropTypes.object.isRequired,
  subject: PropTypes.string.isRequired,
  educationPeriodCode: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default useFetchTeacher;
